//register global actions
import { GlobalActions } from "redux-subspace";
import "../../../data/redux-form-globals";

import { types } from "../../../data/user";

GlobalActions.register(types.RESET_CURRENT_USER);
